export const DEFAULT_BRANDING_SETTINGS = {
  primaryColour: '#18181b',
  primaryAccentColour: '#d9d9d9',
  secondaryColour: '#fafafa',
  secondaryAccentColour: '#fafafa',
  primaryBtnColour: '#18181b',
  secondaryBtnColour: '#18181b',
  primaryBtnHoverColour: '#18181bcc',
  secondaryBtnHoverColour: '#18181bcc',
  primaryBtnTextColour: '#ffffff',
  secondaryBtnTextColour: '#18181b',
  primaryBtnHoverTextColour: '#ffffff',
  secondaryBtnHoverTextColour: '#18181b',
  backgroundColour: '#f7f7f9',
  headerBackgroundColour: '#ffffff',
  mainWrapperBackgroundColour: '#ffffff',
  mainWrapperPaddingTop: '0px',
  mainWrapperPaddingRight: '0px',
  mainWrapperPaddingBottom: '0px',
  mainWrapperPaddingLeft: '0px',
  tableHeaderBackgroundColour: '#f8f9fa',
  logoUrl: '',
  companyName: 'Aricoma'
};
